export enum CaptchaType {
  None = 'none',
  RecaptchaV2 = 'recaptcha_v2'
}

export const captchaConfigurations: Record<CaptchaType, CaptchaConfig> = {
  [CaptchaType.RecaptchaV2]: {
    sitekey: '6LcuiyUeAAAAAA1tiYt20PDSLTcvooTBEsGy2zUu',
    badge: 'bottomleft'
  },
  [CaptchaType.None]: {
    sitekey: '6LcuiyUeAAAAAA1tiYt20PDSLTcvooTBEsGy2zUu',
    badge: 'bottomleft'
  }
};

export interface CaptchaConfig {
  sitekey?: string;
  callback?: Function;
  'expired-callback'?: Function;
  badge?: string;
}

export enum CaptchaStatus {
  NotRequired,
  Uninitialised,
  Loading,
  Pending,
  Resolved
}

export namespace CaptchaType {
  export function fromString(typeString: string): CaptchaType {
    if (Object.values(CaptchaType).includes(typeString as CaptchaType)) {
      return typeString as CaptchaType
    } else {
      return CaptchaType.None;
    }
  }
}
